import React from 'react';
import { Typography, Box } from '@mui/material';

interface EntityListItem {
  id: string;
  name: string;
  [key: string]: any;
}

interface EntitySearchResultsProps {
  results: EntityListItem[];
  onSelect: (entity: EntityListItem) => void;
  renderItem?: (entity: EntityListItem) => React.ReactNode;
  emptyMessage?: string;
}

const EntitySearchResults: React.FC<EntitySearchResultsProps> = ({
  results,
  onSelect,
  renderItem,
  emptyMessage = 'No results found'
}) => {
  if (results.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center', color: 'text.secondary', fontStyle: 'italic' }}>
        {emptyMessage}
      </Box>
    );
  }

  const defaultRenderItem = (entity: EntityListItem) => (
    <>
      <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
        {entity.name}
      </Typography>
      {entity.summary_description && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          {entity.summary_description}
        </Typography>
      )}
    </>
  );

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      maxHeight: '500px',
      overflowY: 'auto',
      pr: 1
    }}>
      {results.map((entity) => (
        <Box
          key={entity.id}
          onClick={() => onSelect(entity)}
          sx={{
            p: 3,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              borderColor: 'primary.main',
              backgroundColor: 'action.hover',
              transform: 'translateY(-2px)',
              boxShadow: 2,
            }
          }}
        >
          {renderItem ? renderItem(entity) : defaultRenderItem(entity)}
        </Box>
      ))}
    </Box>
  );
};

export default EntitySearchResults;
